module.exports = __webpack_public_path__ + "img/profil_lapper_leif-kåre.c47352df.png";